/** @format */

import { useEffect } from "react";
import Logout from "./Logout";
import BLSpinner from "../assets/animations/BLSpinner/BLSpinner";
import Callback from "./Callback";

const Bblogin = () => {
  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_RESOURCES_FILTER_URL}/auth/login?redirect_uri=${process.env.REACT_APP_RESOURCES_EBL_URL}/auth/callback`;
  }, []);
  return (
    <div className="d-flex justify-content-center m-2">
      <BLSpinner />
    </div>
  );
};

const HwbLogin = () => {
  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_RESOURCES_FILTER_URL}/auth/login?service=hwb&redirect_uri=${process.env.REACT_APP_RESOURCES_EBL_URL}/auth/callback`;
  }, []);
  return (
    <div className="d-flex justify-content-center m-2">
      <BLSpinner />
    </div>
  );
};

const authRoutes = [
  {
    path: "bblogin",
    element: <Bblogin />,
    // element: <GoToBBAuthorisation />,
  },
  {
    path: `hwblogin`,
    element: <HwbLogin />,
  },
  {
    path: "callback",
    element: <Callback />,
  },
  {
    path: "logout",
    // TODO: add a logout component
    element: <Logout />,
  },
];

export default authRoutes;
